import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@base-ui/react/dialog';
import { css } from '@repo/pandacss/css';
import { CloseIcon } from '@repo/ui/icons/CloseIcon';
import { NerdWalletLogo } from '@repo/ui/NerdWalletLogo';
export function Header(t0) {
  const $ = _c(6);
  const {
    onDismiss
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = css({
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    });
    t2 = <NerdWalletLogo variant="verbose" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = css({
      bg: "[transparent]",
      border: "none",
      cursor: "pointer",
      color: "neutral.darker",
      width: "[30px]",
      height: "[30px]",
      rounded: "full",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      px: "[0px]",
      _hover: {
        bg: "neutral.lightest"
      }
    });
    t4 = <CloseIcon />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onDismiss) {
    t5 = <div className={t1}>{t2}<Dialog.Close render={<button type="button" aria-label="Close modal" onClick={onDismiss} className={t3}>{t4}</button>} /></div>;
    $[4] = onDismiss;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}